export default __webpack_public_path__ + "4783d13849ecf759c991269aaa2e3ca9.svg";